import { Breakpoints, styled } from '@volkswagen-onehub/components-core';

export const InputBox = styled.div``;

export const StyledSelect = styled.div`
  //flex: 1 0 0;

  //width: 100%;
  //min-width: 192px;
  /*

  flex: 1 0 0;

  @media (min-width: ${Breakpoints.b560}px) {
    &:first-child {
      width: auto;
      max-width: ${(props) => props.theme.size.grid008};
    }
  }

  @media (min-width: ${Breakpoints.b1600}px) {
    &:first-child {
      width: auto;
      max-width: ${(props) => props.theme.size.grid004};
    }
  }*/

  //margin-bottom: 2rem;
`;

export const AutoCompleteContainer = styled.div`
  position: relative;
  margin-bottom: 1rem;
  width: 100%;
`;

export const InputWrapper = styled.div<{ $hideLabel?: boolean }>`
  position: relative;
  width: 100%;

  > label {
    padding: 0 48px 0 16px !important;
  }

  ${({ $hideLabel }) =>
    $hideLabel &&
    `
    label p {
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      white-space: nowrap;
      border-width: 0;
    }
  `}
`;

export const ClearButton = styled.button`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.7;
  }

  &:active {
    opacity: 0.5;
  }
`;

export const DropdownList = styled.ul`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  width: 100%;
  margin: 4px 0 0 0;
  padding: 4px 0;
  list-style: none;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 10;
  max-height: 220px;
  overflow-y: auto;
  box-sizing: border-box;
`;

export const DropdownOptionWrapper = styled.li`
  cursor: pointer;

  &:hover {
    background-color: rgba(25, 118, 210, 0.08);
  }

  &:active {
    background-color: rgba(25, 118, 210, 0.15);
  }

  &:focus {
    outline: none;
    background-color: rgba(25, 118, 210, 0.12);
  }
`;

export const CustomDropdownOption = styled.li`
  padding: 8px 12px;
  cursor: pointer;
  font-size: 0.875rem;
  line-height: 1.5;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: rgba(25, 118, 210, 0.08);
  }

  &:active {
    background-color: rgba(25, 118, 210, 0.15);
  }

  &:focus {
    outline: none;
    background-color: rgba(25, 118, 210, 0.12);
  }
`;

export const HighlightedText = styled.span`
  font-weight: 600;
  /*background-color: rgba(25, 118, 210, 0.15);
  padding: 0 2px;
  border-radius: 2px;*/
`;

export const StyledErrorMessage = styled.div`
  display: flex;
  margin-top: 10px;
  color: ${(props) => props.theme.colors.signal.error};
`;
